export default __webpack_public_path__ + "static/media/Group 6499@3x.31ece0a9.png";